import { Controller } from "@hotwired/stimulus"

// ユーザーアクティブ状態切り替えを制御するStimulusコントローラー
export default class extends Controller {
  static values = { url: String, current: Boolean }

  // アクティブ状態をトグル
  async toggle(event) {
    event.preventDefault()

    const button = event.target
    const originalText = button.innerHTML

    // ボタンを無効化してローディング表示
    button.disabled = true
    button.innerHTML = '<i class="fa-solid fa-spinner fa-spin me-1"></i>処理中...'

    try {
      const response = await fetch(this.urlValue, {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
        }
      })

      const data = await response.json()

      if (data.success) {
        // 成功時: ボタンの表示とステータスバッジを更新
        this.updateButton(button, data.is_active)
        this.updateStatusBadge(data.is_active)

        // 成功メッセージを一時的に表示
        this.showSuccessMessage(data.message)
      } else {
        alert('エラー: ' + data.message)
      }
    } catch (error) {
      console.error('ステータス切り替えエラー:', error)
      alert('通信エラーが発生しました')
    } finally {
      // ボタンを再有効化
      button.disabled = false
    }
  }

  // ボタンの表示を更新
  updateButton(button, isActive) {
    const iconClass = 'fa-solid fa-power-off me-1'
    const text = isActive ? '無効化' : '有効化'
    const buttonClass = isActive ? 'btn btn-outline-warning' : 'btn btn-outline-success'

    button.innerHTML = `<i class="${iconClass}"></i>${text}`
    button.className = buttonClass

    // data属性も更新
    this.currentValue = isActive
  }

  // ステータスバッジを更新
  updateStatusBadge(isActive) {
    // ユーザー詳細画面のステータスバッジを探して更新
    const statusCell = document.querySelector('dd .badge')
    if (statusCell) {
      if (isActive) {
        statusCell.className = 'badge bg-success'
        statusCell.textContent = 'アクティブ'
      } else {
        statusCell.className = 'badge bg-secondary'
        statusCell.textContent = '非アクティブ'
      }
    }
  }

  // 成功メッセージを一時的に表示
  showSuccessMessage(message) {
    // 簡単なトーストメッセージを作成
    const toast = document.createElement('div')
    toast.className = 'toast align-items-center text-white bg-success border-0 position-fixed top-0 end-0 mt-3 me-3'
    toast.style.zIndex = '9999'
    toast.innerHTML = `
      <div class="d-flex">
        <div class="toast-body">
          <i class="fa-solid fa-check-circle me-2"></i>${message}
        </div>
        <button type="button" class="btn-close btn-close-white me-2 m-auto" data-bs-dismiss="toast"></button>
      </div>
    `

    document.body.appendChild(toast)

    // Bootstrapトーストを初期化して表示
    const bsToast = new window.bootstrap.Toast(toast, {
      autohide: true,
      delay: 3000
    })

    bsToast.show()

    // トーストが隠れた後に要素を削除
    toast.addEventListener('hidden.bs.toast', () => {
      toast.remove()
    })
  }
}
